import {Module} from '@mamdev/cad.static-next-lib';
import Viewport from '../../ts/services/viewport';

export default class Standalone extends Module {
  // Init. from DOM.
  static attachTo(root: HTMLElement): Standalone {
    return new Standalone(root);
  }

  constructor(root: HTMLElement) {
    super(root);
    this.name_ = 'standalone';
  }

  // Start the module.
  start() {
    try {
      this.log('standalone init');
      this.attachEventListeners();
    } catch (e) {
      this.logUnknownError(e, true);
    }
  }

  // Attach event listeners for body clicked
  attachEventListeners() {
    this.root_.addEventListener('click', () => {
      if (Viewport.matches('desktop')) {
        this.publish('article:bodyClicked');
      }
    });
  }
}
